import { BASE_URL } from "./apiConfig";
import apiClient from "./apiInstance";

// Fetch schedule records by campaign ID
export const getschedule = async (campaignID) => {
  try {
    console.log("Calling API with campaignID:", campaignID);
    const response = await apiClient.get(`${BASE_URL}/getschedule`, {
      params: { campaignID },
    });
    console.log("API Response:", response.data); // Log response from backend
    return response.data;
  } catch (error) {
    console.error("Error fetching schedule:", error);
    throw error;
  }
};

// update schedule
export const saveSchedule = async (scheduleID) => {
  try {
    const response = await apiClient.post(
      `${BASE_URL}/saveschedule`,
      scheduleID,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error saving schedule:", error);
    throw error;
  }
};

// Add a New schedule
export const addSchedule = async (campaignID, title) => {
  try {
    if (!campaignID || !title) {
      throw new Error("Campaign ID and Title are required");
    }

    const response = await apiClient({
      method: "post",
      url: `${BASE_URL}/addschedule?campaignID=${campaignID}`,
      headers: { "Content-Type": "application/json" },
      data: { title }, // Ensure title is sent in the body
    });

    return response.data;
  } catch (error) {
    console.error(
      "Error adding schedule:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

// Delete a schedule by ID
export const deleteSchedule = async (scheduleID) => {
  try {
    if (!scheduleID) throw new Error("Schedule ID is required");
    const response = await apiClient.post(
      `${BASE_URL}/deleteschedule`,
      { scheduleID },
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error deleting schedule:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

// Return array of schedule IDs for a campaign
export const getScheduleIds = async (campaignID) => {
  try {
    const response = await apiClient.get(`${BASE_URL}/getscheduleIds`, {
      params: { campaignID },
    });
    const data = response.data;
    if (!Array.isArray(data)) return "";
    const ids = data.map((s) => s.id);
    return ids.join(",");
  } catch (error) {
    console.error("Error getting schedule ids:", error);
    throw error;
  }
};

// Fetch DPD values from backend
export const getDpds = async () => {
  try {
    const response = await apiClient.get(`${BASE_URL}/getdpds`);
    // Expect response.data to be an array of dpd values or objects
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching dpds:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const getMessagesBydpd = async (dpd) => {
  try {
    const response = await apiClient.get(`${BASE_URL}/getMessagesBydpd`, {
      params: { dpd },
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching dpd messages:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const getMessages = async () => {
  try {
    const response = await apiClient.get(`${BASE_URL}/getMessages`);
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching messages:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

// Update a message by id (calls backend /updateMessageById)
export const updateMessageById = async (id, message) => {
  try {
    if (!id) throw new Error("Message id is required");
    // Use POST to update server record
    const response = await apiClient.post(
      `${BASE_URL}/updateMessageById`,
      { id, message },
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error updating message:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

// Create a new campaign message. Accepts payload: { type, typeValue, message }
export const createMessage = async (payload) => {
  try {
    if (!payload) throw new Error("Payload is required");
    if (!payload.type) throw new Error("type is required");
    if (payload.message === undefined) throw new Error("message is required");
    const response = await apiClient.post(
      `${BASE_URL}/createMessage`,
      payload,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return response.data; // { message: 'Created', id }
  } catch (error) {
    console.error(
      "Error creating message:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

// Save a full campaign message (Channel, Language, DPD, State, FromDBAName, TemplateName, Description)
export const saveCampaignMessage = async (payload) => {
  try {
    if (!payload || !payload.Description) throw new Error("Description is required");
    const response = await apiClient.post(`${BASE_URL}/saveCampaignMessage`, payload, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error saving campaign message:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};
